import type { Environment } from '#utils/environments/records/Environment';

import { EnvironmentMultiSelect, type EnvironmentMultiSelectProps } from './EnvironmentMultiSelect';

export type EnvironmentSelectProps = {
  selectedEnvironment?: Environment;
  onChange: (environmentId: string, option?: EnvironmentSelectOption) => void;
} & Omit<EnvironmentMultiSelectProps, 'onChange' | 'isMulti' | 'selectedEnvironments'>;

export type EnvironmentSelectOption = {
  value: string;
  label: string;
  environment: Environment;
  key: string;
  projectName?: string;
  projectKey?: string;
};

export function EnvironmentSelect({ selectedEnvironment, onChange, ...props }: EnvironmentSelectProps) {
  const handleOnChange = (ids: string[], envs?: EnvironmentSelectOption[]) => {
    if (envs && envs.length > 0) {
      onChange(ids[0], envs[0]);
    }
  };

  return (
    <EnvironmentMultiSelect
      {...props}
      selectedEnvironments={selectedEnvironment ? [selectedEnvironment] : []}
      onChange={handleOnChange}
      isMulti={false}
    />
  );
}
